import { useNavigate } from "react-router-dom";
import defaultImage from "assets/images/imgs/class_default_img.jpg";
import "./shoppingCard.scss";

const ShoppingCard = ({ info }) => {
    const navigate = useNavigate();

    const getImageUrl = () => {
        if (Array.isArray(info.images) && info?.images.length > 0) {
            return info.images[0].image;
        }
        return defaultImage;
    };

    return (
        <div
            className="shopping-card-container"
            onClick={() => {
                navigate(`/product/detail/${info.id}`);
            }}
        >
            <img
                src={getImageUrl()}
                alt={info.description || info.title || "클래스 이미지"}
                onError={(e) => {
                    e.currentTarget.src = defaultImage;
                }}
            />
            <div className="shopping-card-content">
                <p className="title">{`[${info.brand}] ${info.name}`}</p>
                <p className="price-wrap">
                    {info.discount_rate !== null && info.discount_rate > 0 && (
                        <span className="discount">
                            {Math.floor(info.discount_rate)}%
                        </span>
                    )}

                    <span className="price">
                        {Number(
                            info.discount_price || info.price
                        ).toLocaleString()}
                        원
                    </span>
                </p>
            </div>
            {/* <div className="shopping-review-wrap">
                <p className="review-count">리뷰 {info.review_count || 0}개</p>
            </div> */}
        </div>
    );
};

export default ShoppingCard;
